import { createContext } from 'react'

import { VersionContext } from './VersionsContext.types'
export const VersionsContext = createContext<VersionContext | undefined>(undefined)
